import { Grid, CircularProgress, stepContentClasses } from "@mui/material";
import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import API from "../../utils/API";
import PCard from "../../components/pos/PCard.jsx";
import PConfirm from "../../components/pos/PConfirm";
import { useTranslation } from "react-i18next";

export default function WarehouseSync(props) {
  const { t } = useTranslation();
  const translate = t;

  const [financialYearId, setFinancialYearId] = useState("");
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmContext, setConfirmContext] = useState({ open: false });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadFinancialYear();
  }, []);

  async function loadFinancialYear() {
    let { data } = await API.get("/api/v1/currentfinancialyear");
    setFinancialYearId(data.id);
  }

  async function startSync() {
    console.log("sync Started called");
    setLoading(true);
    try {
      let payload = {
        financialYearId: financialYearId,
      };
      let { data } = await API.post("/api/v1/workrequest", {
        actionType: "sync_product_data_with_branches",
        playload: JSON.stringify(payload),
      });

      while (true) {
        let result = await API.get("/api/v1/workrequest/" + data.id);
        console.log(result.data);
        if (result.data.status === "Failed") {
          props.setAlert({
            show: true,
            title: translate("Alert!"),
            message: translate("Data Sync Failed, please contact support"),
          });
          break;
        } else if (result.data.status === "Completed") {
          props.setAlert({
            show: true,
            title: translate("Success!"),
            message: translate("Data Synced successfully"),
          });
          break;
        }
        await sleep(5000);
      }

      setLoading(false);
    } catch (err) {
      setLoading(false);
      props.setAlert({
        show: true,
        title: translate("Alert!"),
        message: translate("Something went wrong!"),
      });
      console.log(err);
    }
  }

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async function onYesNoClicked(context, value) {
    console.log(context, value);
    if (context.eventType === "syncProduyctDataWithBranch" && value === "yes") {
      console.log("startMigration called 1");
      await startSync();
    }
    setConfirmOpen(false);

    // setBlockYearEnding(true);
  }

  // function showDetailedError(err) {}

  async function startMigration() {
    setConfirmOpen(true);
    setConfirmContext({
      title: translate("Sync Product Data with Branches"),
      message: translate(
        "All Data will be getting Synced with Branches Except price"
      ),
      type: "warning",
      eventType: "syncProduyctDataWithBranch",
      open: true,
      yes: true,
      no: true,
    });
  }

  var biRef = {};
  const content = (
    <div>
      {
        <Button onClick={startMigration} variant="contained" disabled={loading}>
          {loading && <CircularProgress size={20} />}
          Sync Data
        </Button>
      }

      {confirmOpen && (
        <PConfirm
          open={confirmOpen}
          context={confirmContext}
          onButtonClicked={onYesNoClicked}
        ></PConfirm>
      )}
    </div>
  );

  const customTitle = "Sync Master Data with Branches";

  return <PCard avatar="R" title={customTitle} content={content}></PCard>;
}
